import cx from "classnames";
import { Component } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { BetSlipHelper } from "../../../../helpers/betSlipHelper";
import { TranslationHelper } from "../../../../helpers/translationHelper";
import type { BetSlipType } from "../../../../types/betSlipType";
import type {
  EventMarketType,
  EventRunnerType,
} from "../../../../types/eventType";
import { BetSlipStates } from "../../../../utils/const";
import { IconClose } from "../../../Icon/Icon";
import "./BetNotification.scss";
type Props = {
  betSlip: BetSlipType;
  removeBetSlip: (...args: Array<any>) => any;
};

class BetNotification extends Component<Props> {
  render() {
    const { betSlip, removeBetSlip } = this.props;
    const betSlipMarket: EventMarketType | null =
      BetSlipHelper.getBetSlipMarket(betSlip);
    const betSlipOdd: EventRunnerType | null =
      BetSlipHelper.getBetSlipOdd(betSlip);

    // If the market or odd is null then don't render it
    if (betSlipMarket == null || betSlipOdd == null) {
      return null;
    }

    const betCompleted = betSlip.state === BetSlipStates.FINISHED;
    let isHandicap = false;
    let handicapName = "";

    switch (betSlipMarket.type) {
      case "HANDICAP":
        isHandicap = true;
        handicapName = "events-handicap";
        break;

      case "CORNER_HANDICAP":
        isHandicap = true;
        handicapName = "bet-betslip-corner-handicap";
        break;

      default:
        break;
    }

    return (
      <div
        className={cx("bet-notification", {
          "bet-notification--completed": betCompleted,
          "bet-notification--failed": !betCompleted,
        })}
      >
        <div
          className="bet-notification__close"
          onClick={() => {
            removeBetSlip(betSlip.localId);
          }}
        >
          <IconClose currentColor className="bet-notification__close-icon" />
        </div>
        <div className="bet-notification__content">
          <strong>
            {betCompleted ? (
              <FormattedMessage tagName="span" id="bets-betaccepted" />
            ) : (
              <FormattedMessage
                tagName="span"
                id="bets-submissionunsuccesful"
              />
            )}
          </strong>
          <br />
          {betSlipOdd.name}
          <br />
          {isHandicap ? (
            <FormattedMessage tagName="span" id={handicapName} />
          ) : (
            betSlipMarket.name
          )}
          {` `}(
          <FormattedMessage
            tagName="span"
            id={TranslationHelper.getTranslationIdForMarket(
              betSlipMarket.period
            )}
          />
          )
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  removeBetSlip: betSlipId => {
    dispatch.betSlipListModel.removeBetSlip(betSlipId);
  },
});

export default connect(null, mapDispatchToProps)(BetNotification) as any;
